import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fab } from '@mui/material';
import { Icon } from '../../atoms';
import { useTheme } from '../../theme';
export function ImagePreview({ imageURL, resetImageBlob }) {
    const theme = useTheme();
    return (_jsxs("div", { style: {
            position: 'relative',
        }, children: [_jsx(Fab, { size: "small", variant: "circular", color: "info", onClick: resetImageBlob, sx: {
                    top: '-16px',
                    right: '-16px',
                    position: 'absolute',
                    zIndex: 100,
                }, children: _jsx(Icon, { variant: "bin", size: "medium", color: theme.palette.error.main }) }), _jsx("img", { alt: "image to upload", src: imageURL, height: "100%", width: "100%" })] }));
}
